import React, { createContext, useContext, useState, useCallback } from 'react';
import { makeRequest } from '../assets/functions_helper';

const SubscriptionUsageContext = createContext(null);

export const SubscriptionUsageProvider = ({ children }) => {
  const [usageInfo, setUsageInfo] = useState({
    products: { used: 0, limit: 0, remaining: 0 },
    images: { used: 0, limit: 0, remaining: 0 },
    ai_prompts: { used: 0, limit: 0, remaining: 0 },
    billing_period_end: null,
    hasSubscription: true,
    isLoading: false,
  });

  const fetchUsage = useCallback((restaurantId) => {
    if (!restaurantId) return;
    
    setUsageInfo(prev => ({ ...prev, isLoading: true }));
    
    makeRequest(
      "GET",
      `subscriptions_router/subscription_usage/${restaurantId}`,
      null,
      "application/json",
      localStorage.getItem("token"),
      localStorage.getItem("tokenType"),
      null,
      true // disable common global loader
    )
      .then((data) => {
        setUsageInfo({
          ...data,
          hasSubscription: true,
          isLoading: false
        });
      })
      .catch((error) => {
        // If 404 or any error, we assume free/trial mode or no enforced limits visually
        setUsageInfo({
          products: { used: 0, limit: 0, remaining: 9999 },
          images: { used: 0, limit: 0, remaining: 9999 },
          ai_prompts: { used: 0, limit: 0, remaining: 9999 },
          billing_period_end: null,
          hasSubscription: false,
          isLoading: false
        });
      });
  }, []);

  const value = React.useMemo(() => ({
    usageInfo,
    fetchUsage
  }), [usageInfo, fetchUsage]);

  return (
    <SubscriptionUsageContext.Provider value={value}>
      {children}
    </SubscriptionUsageContext.Provider>
  );
};

export const useSubscriptionUsage = () => {
  const context = useContext(SubscriptionUsageContext);
  if (!context) {
    throw new Error("useSubscriptionUsage out of Provider");
  }
  return context;
};
